import React from "react";
import Breadcrumbs from "../../../components/Breadcrumbs";

const TermsandConditions = () => {
  return (
    <>
      <div className="page-wrapper">
        {/* Page Content */}
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle=" الأحكام والشروط "
            title=" الرئيسية"
            subtitle=" الأحكام والشروط"
          />
          <div className="small-container">
            <div className="card flex-fill accessibility-statement">
              <div className="inner-header text-center text-primary card-header p-3">
                <h1>شروط الاستخدام</h1>
              </div>
              <div className="card-body">
                <div className="inner-content text-right account-wrapper login-black content pt-0 ">
                  <div className="card-header pt-0">
                    <h3 className="text-primary card-title">عامة</h3>
                  </div>

                  <ul className="text-primary-ol list-disc p-3 pt-0">
                    <li>
                      تقوم منصة Fintrack و أو، ("الشركة") بتشغيل نظام يتيح إنتاج
                      وإرسال الفواتير الرقمية ومستندات الأعمال والإيصالات و
                      إدارة مشاريع عبر الإنترنت. تحكم شروط الاستخدام الواردة
                      أدناه ("شروط الاستخدام" أو "الاتفاقية") العلاقة بين الشركة
                      والمستخدم (على النحو المحدد أدناه) فيما يتعلق باستخدام
                      النظام الأساسي كما هو محدد أدناه).
                    </li>
                    <li>
                      لا تنتقص شروط الاستخدام من أي اتفاقية أخرى بين المستخدم
                      والشركة أو تغيرها. في حالة وجود تناقض بين شروط الاستخدام
                      والمستندات الفردية الأخرى ، يسود ما ورد في المستندات
                      الأخرى ، ما لم ينص على خلاف ذلك. دون الخروج عن ما ورد
                      أعلاه ، في أي حالة من التناقض أو التناقض بين شروط
                      الاستخدام والشروط أو التعليمات المنشورة في أي وسيلة
                      إعلانية أخرى ، تسود أحكام شروط الاستخدام. يشكل استخدام
                      المنصة موافقة وقبول شروط هذه الاتفاقية. لا يُسمح للمستخدم
                      الذي لا يوافق على شروط الاستخدام (جزئياً أو كلياً) المنصوص
                      عليها في هذه الاتفاقية ، باستخدام أي منصة أو جزء منها.
                    </li>
                    <li>
                      نوضح هنا أن شروط هذه الاتفاقية تعمل بالتزامن مع شروط
                      استخدام الأطراف الثالثة وتخضع لها ، إلى الحد الذي قد يكون
                      هناك أي منها ، وتأتي لتضيف إليها. الاتفاقية مكتوبة بلغة
                      المذكر لدواعي التسهيل فقط وتستهدف كلا الجنسين.
                    </li>
                    <li>
                      تم إدراج عناوين الأقسام للتسهيل فقط ولا ولن يتم إعطاء أي
                      وزن في التفسير المنصوص عليه في شروط الاستخدام. تنطبق جميع
                      التعليمات الواردة في شروط الاستخدام المتعلقة بمقاصة بطاقة
                      الائتمان على أي مستخدم اشترى الوظيفة الإضافية للمقاصة (كما
                      هو موضح أدناه) ، ويستخدم المنصة ، من بين أشياء أخرى ، لغرض
                      مقاصة معاملات بطاقة الائتمان.
                    </li>
                    <li>
                      سياسة خصوصية الشركة ("سياسة الخصوصية") متاحة على
                      fintrack.com وهي جزء لا يتجزأ من شروط الاستخدام هذه.
                    </li>
                  </ul>
                  <div className="card-header">
                    <h3 className="text-primary card-title">التعاريف</h3>
                  </div>

                  <ul className="text-primary-ol list-disc p-3 pt-0">
                    <li>
                      سيكون للمصطلحات التالية المعنى الذي يظهر بجانبها ، ما لم
                      ينص صراحة على خلاف ذلك: "المستخدم" أو "المستخدمون" - أي
                      شخص يستخدم النظام الأساسي أو موقع الشركة على الويب.
                    </li>
                  </ul>
                  <div className="card-header">
                    <h3 className="text-primary card-title">التزام المستخدم</h3>
                  </div>

                  <ul className="text-primary-ol list-disc p-3 pt-0">
                    <li>
                      <span className="text-primary">
                        {" "}
                        يتعهد المستخدم بالامتناع عن تنفيذ الإجراءات التالية فيما
                        يتعلق بالمنصة:
                      </span>
                      <ol>
                        <li>
                          التصفح أو المسح الضوئي أو استخدام النظام الأساسي
                          باستخدام برامج الكمبيوتر المصممة لجمع المعلومات ، أو
                          لتنفيذ الإجراءات عن طريق تقليد متصفحي الأمواج العادي ،
                          بما في ذلك الروبوتات أو برامج الزحف وما شابه ذلك
                        </li>
                        <li>
                          التلاعب بعنوان URL للصفحات الداخلية ، من أجل الوصول
                          إلى الصفحات الداخلية التي ليس لديه وصول مباشر إليها
                          (URL Hacking)
                        </li>
                        <li>
                          تحميل أو نقل المحتوى أو تنفيذ الإجراءات التي تعتبر
                          انتهاكاً لأي قانون ؛ نقل أو نشر محتوى ينتهك حقوق الطبع
                          والنشر أو العلامة التجارية أو الأسرار التجارية أو أي
                          ملكية فكرية لشخص آخر ، أو نشر تشهير أو فاحشة أو ينتهك
                          خصوصية الآخرين
                        </li>
                        <li>
                          القيام بعمل ما في تصميم الموقع أو التطبيق أو الكود
                          المصدري أو العناصر أو المحتوى الظاهر على الموقع أو
                          التطبيق.
                        </li>
                        <li>
                          يصرح المستخدمون بموجب هذا أن أي عمل سيتم فتحه في
                          حسابهم على الموقع ، مملوك لهم ، أو أنهم موظفون من قبله
                          ، ومسجل قانونيًا في إسرائيل.
                        </li>
                        <li>
                          على الرغم مما ورد أعلاه ودون الخروج عن القسم 5. أدناه
                          ، سيتم توضيح أنه في أي حالة يتم فيها فتح حساب (كما هو
                          موضح أدناه) ، والذي يتم استخدامه من قبل شركة معينة أو
                          عدة شركات ، من قبل طرف ثالث ، ثم الحساب و جميع
                          المعلومات المتعلقة به ستكون ملكاً لمالكها. لن يكون لدى
                          الشركة أو أصحاب الأعمال الذين يستخدمون الحساب المذكور
                          أعلاه والطرف الثالث الذي فتح الحساب المذكور أي حقوق
                          فيما يتعلق بهذا الحساب. تحتفظ الشركة بالحق في تنفيذ أي
                          إجراء على الحساب المذكور أعلاه ، بما في ذلك إغلاقه ،
                          وفقاً لتقديرها الخاص وعندما يتضح أن الحساب ينتهك شروط
                          الاستخدام أو أحكام القانون.
                        </li>
                        <li>
                          تقع على عاتق المستخدم مسؤولية التحقق ، قبل استخدام
                          المنصة ، من أن المنصة مناسبة بالفعل لاحتياجاته ، ولن
                          يكون للمستخدم أي مطالبة بسبب عدم ملاءمة المنصة
                          لاحتياجاته.
                        </li>
                      </ol>
                    </li>
                  </ul>
                  <div className="card-header">
                    <h3 className="text-primary card-title">المنصة, الرخصه</h3>
                  </div>

                  <ul className="text-primary-ol list-disc p-3 pt-0">
                    {" "}
                    <li>
                      توفر الشركة من خلال المنصة، من بين أشياء أخرى، ترخيصاً
                      لتنفيذ الإجراءات التالية (المشار إليها فيما يلي باسم
                      "الترخيص"):
                      <ol>
                        <li>
                          إنتاج وإرسال جميع المستندات عبر البريد الإلكتروني أو
                          PDF (لا يوجد التزام للطباعة)؛
                        </li>
                        <li>
                          إنشاء فواتير / إيصالات بنقرة زر من حساب المعاملات؛
                        </li>
                        <li>
                          التشغيل التلقائي لمقاصة بطاقات الائتمان والدفع
                          المستقل؛
                        </li>
                        <li>
                          تخصيص الملاحظات الدائمة على الفاتورة - باللغتين
                          العبرية والإنجليزية؛
                        </li>
                        <li>
                          إصدار الفواتير باللغات الإنجليزية والعبرية وبعملات
                          مختلفة مثل الشيكل والدولار واليورو وغيرها.
                        </li>
                      </ol>
                    </li>
                    <li>
                      سيتم منح الترخيص للمستخدمين الذين يمارسون أنشطة تجارية.
                      سيتم منح الترخيص وفقاً لحزمة الاستخدام التي اشتراها
                      المستخدم ("حزمة الاستخدام"). من الواضح أن كل حزمة استخدام
                      ستسمح بنطاق مختلف من العمليات. لمزيد من المعلومات حول حزم
                      الاستخدام، ونطاق العمليات المدرجة في الترخيص المرفق بها
                      وتكلفتها - fintrack.com.
                    </li>
                    <li>
                      ما ورد في القسم 4 أعلاه هو للتوضيح فقط ولا يستنفذ جميع
                      الإجراءات التي يمكن القيام بها بمساعدة النظام الأساسي.
                      للاستفسارات أو الأسئلة المتعلقة بالترخيص، يمكنك الاتصال
                      بممثل الشركة عبر البريد الإلكتروني support@massarwe.com.
                    </li>
                    <li>
                      يشكل جزء من الترخيص الذي تقدمه الشركة في مجال مقاصة
                      معاملات بطاقات الائتمان اتصالاً أو ارتباطاً بالكيانات التي
                      تقوم بالفعل بإجراء المقاصة وهي مشروطة بمشاركة المستخدم
                      المباشرة في اتفاقية ملزمة مع الكيان المرخص له. يتم دخول
                      المستخدم في اتفاقية تسوية معاملات بطاقة الائتمان على
                      مسؤولية المستخدم وهو مطالب بإجراء جميع الفحوصات المطلوبة
                      قبل إجراء الاتصال. أي إجراء يتم إجراؤه على المنصة فيما
                      يتعلق بتسوية معاملات بطاقة الائتمان سيتم تنفيذه من خلال
                      الطرف المخلص فقط، وتحت مسؤوليته، ووفقاً لشروط عقد المستخدم
                      مع الطرف المخالف. الارتباط الذي توفره الشركة لطرف المقاصة
                      لا يسمح لها بأن تكون مسؤولة عن خدمات المقاصة المقدمة
                      للمستخدم من قبل أطراف ثالثة وفقا لأحكام اتفاقيات المقاصة.
                    </li>
                    <li>
                      يوافق العمل ويؤكد بموجب هذا أنه يجوز لممثلي Fintrack تسجيل
                      الدخول إلى الحساب الشخصي للشركة في النظام في أي وقت، من
                      بين أمور أخرى (ولكن ليس فقط) لإجراء الاختبارات الفنية و/أو
                      المساعدة في أي أسئلة و/أو أعطال في النظام و/أو تشغيله.
                    </li>
                    <li>
                      تقع على عاتق المستخدم مسؤولية التحقق من صحة الفواتير التي
                      يتلقاها من جهات خارجية وتحويلها من خلال تطبيق "واتساب"
                      واستلامها على الموقع المذكور أعلاه. الشركة غير مسؤولة عن
                      العيوب الناتجة عن أي خلل في تطبيق "واتس اب" أو عدم استلام
                      الفواتير على الموقع أو صحة الفواتير.
                    </li>
                    <li>
                      تمت كتابة الاتفاق بلغة الذكور فقط للراحة، ويهدف إلى جميع
                      الجنسين.
                    </li>
                    <li>
                      <strong>سعر وإلغاء الإلغاء</strong>
                      <ul>
                        <li>
                          جدول السعر لإنشاء صفحة مبيعات باستخدام النظام موجود في
                          صفحة "القائمة" في موقع الفاتورة الخضراء. قد تقوم
                          Fintrack بتغيير قائمة الأسعار من وقت لآخر وفقاً
                          لتقديرها الخاص.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>تقييد الاستخدام</strong>
                      <ul>
                        <li>
                          يتعهد الشركة بعدم استخدام صفحات النظام والبيع للأهداف
                          غير القانونية. ستبيع الأعمال المنتجات و/أو الخدمات
                          التي تظهر على صفحات المبيعات وتدير صفحات المبيعات
                          الخاضعة لأي قانون ووفقاً لأي قانون.
                        </li>
                        <li>
                          يتعهد الشركة بتعويض Fintrack وتعويضها في أي حالة من
                          شكوى أي طرف ثالث أو مطالبة بخصوص تشغيل صفحة المبيعات
                          أو بيع المنتجات و/أو الخدمات على صفحة المبيعات غير
                          وفقًا لأحكام القانون.
                        </li>
                        <li>
                          يوافق الشركة بموجب هذا على أن ممثلي Fintrack قد يدخلون
                          في أي وقت إلى حساب الأعمال التجارية في النظام، بما في
                          ذلك (ولكن ليس فقط) لإجراء الاختبارات الفنية و/أو
                          المساعدة في أي أسئلة و/أو عطل في النظام و/ أو العملية.
                        </li>
                        <li>
                          ستتضمن كل صفحة مبيعات سياسات تفصل شروط مبيعات المنتجات
                          أو الخدمات بين الأعمال والمشترين. ستكون السياسة
                          الواردة في صفحة المبيعات في الصياغة التي سيتم تصميمها
                          لجميع حماية المستهلك بموجب قانون حماية المستهلك
                          ولوائحه، ولأي قانون آخر ينطبق على صفحة البيع. ستكون
                          الشركة مسؤولة عن التصرف في بيع المنتجات وفقاً لمثل هذا
                          القانون، حيث قد يكون من وقت لآخر. Fintrack، لن تكون
                          هناك مسؤولية عن ذلك. وتوضيح بموجب هذا أن الصياغة
                          المقترحة هي الصياغة التي تنعكس في رأي Fintrack، تتحمل
                          أحكام القانون على إخطار Fintrack عن أي تغيير أو تعديل،
                          بما في ذلك التغيير.
                        </li>
                        <li>
                          تعلن العمل بموجبه أنه من المدروس أن Fintrack حريصة على
                          تنفيذ الأعمال التجارية وفقاً لأحكام قانون حماية
                          المستهلك واللوائح بحكمها، وأن شروط الاستخدام ستعكس هذه
                          الأحكام.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>المسؤولية</strong>
                      <ul>
                        <li>
                          يعلن العمل أنه فحص النظام قبل التعلق ووجد أن هذا
                          النظام مناسب لاحتياجاته واستخداماته. يعلن العمل أنه
                          يدرك أن الفواتير الخضراء ليست مسؤولة عن أي استخدام
                          تقوم به في النظام الذي يوفره وهو مسؤول حصرياً عن أي
                          استخدام يقوم به في النظام.
                        </li>
                        <li>
                          العمل هو المسؤول الوحيد عن المحتوى الذي تم إدخاله
                          وعرضه على صفحة المبيعات و/أو الخدمات التي يقدمها للبيع
                          على صفحة المبيعات التي أنشأها من خلال النظام. الضمان
                          الكامل والحصري عندما يتعلق الأمر بالمنتجات و/أو
                          الخدمات، بما في ذلك العرض أو الفشل، و/أو المعاملات من
                          أي نوع مع العملاء النهائيين تنطبق على العمل.
                        </li>
                        <li>
                          ستجعل Fintrack أي جهد معقول للوفاء بنشاط صفحة المبيعات
                          العادية، ولكن لا يمكن الالتزام بالتوافر المستمر ودون
                          خلل في صفحة المبيعات. قد تتوقف Fintrack عن استخدام
                          صفحة المبيعات من وقت لآخر للحفاظ عليها. لن يتم منح أي
                          تعويض مالي أو ائتمان بسبب أعطال أو فترات راحة في
                          النظام.
                        </li>
                        <li>
                          بأي حال من الأحوال، لن يتم تشحيم الأخضر أو الخضار بشكل
                          غير مباشر أو فقدان الاستخدام أو فقدان البيانات أو
                          فقدان الأرباح، مما يؤدي فاتورة خضراء لاستخدام التأخير
                          أو عدم القدرة على إجراء العمليات أو العرض أو التأخير
                          في العرض أو في الفشل في توفير المنتجات أو العمليات، أو
                          أي معلومات أو برامج أو عمل أو منتج ينشأ بأي طريقة أخرى
                          من استخدام النظام و صفحات المبيعات.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>حقوق النشر</strong>
                      <ul>
                        <li>
                          يشكل تحديث البيانات والمحتوى من قبل العمل في النظام
                          بياناً والالتزام من جانبها من خلال وجود حقوق الطبع
                          والنشر في هذه المحتوى، والتي تعد محتوى قانونياً ولا
                          تتعارض مع القانون أو يحظر عليها القانون. تم توضيح
                          بموجب هذا أنه لن يتم فتح فاتورة خضراء ولن تكون مسؤولة
                          عن المحتوى في صفحة المبيعات.
                        </li>
                        <li>
                          تقع على عاتق العمل مسؤولية التحقق من أن لديه الحق في
                          استخدام المحتوى الذي يقوم بتحميله على صفحة المبيعات
                          الخاصة به، بما في ذلك اختبار أن المحتوى غير محمي
                          بواسطة حقوق الطبع والنشر.
                        </li>
                        <li>
                          يوافق الشركة على عدم نسخ أو إعادة إنتاج أي برنامج أو
                          رمز المصدر أو جزء من رمز المصدر للنظام لأي سبب من
                          الأسباب.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>السلطة والحكم</strong>
                      <ul>
                        <li>
                          إن الاختصاص القضائي الفريد والحصري للقضايا والمسائل
                          المتعلقة أو ذات الصلة بشروط الاستخدام هذه لن يكون إلا
                          للمحكمة المختصة التي مقرها القدس. القانون الذي يجب
                          تطبيقه على هذه الاتفاقية فقط.
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <div className="card-header">
                    <h3 className="text-primary card-title">حساب المستخدم</h3>
                  </div>

                  <ul className="text-primary-ol list-disc p-3 pt-0">
                    <li>
                      تحتفظ الشركة بالحق، وفقاً لتقديرها الخاص، في تحديد أن
                      الوصول إلى إجراءات معينة سيكون ممكناً فقط للمستخدم المسجل
                      في الموقع، والذي قدم للشركة بعض التفاصيل التي ستحددها
                      الشركة ("حساب المستخدم" أو "الحساب").
                    </li>
                    <li>
                      يجوز للمستخدم إعداد عدة أعمال تحت حساب المستخدم نفسه،
                      اعتماداً على نوع المشترك الذي اشتراه من الشركة، شريطة أن
                      يكون لكل شركة رقم تسجيل مختلف.
                      <ol>
                        <li>
                          تم توضيح أنه لا يمكن إعداد النظام باستخدام نفس رقم
                          تسجيل العمل لأكثر من حساب مستخدم.
                        </li>
                      </ol>
                    </li>
                    <li>
                      سيتم تطبيق الإرشادات التالية على إنشاء حساب المستخدم:
                      <ol>
                        <li>
                          من الضروري تقديم التفاصيل الكاملة عند فتح الحساب.
                        </li>
                        <li>
                          يجب ألا يحتوي حساب المستخدم على بيانات غير حقيقية أو
                          غير كاملة.
                        </li>
                        <li>
                          يجب ألا يتم إنشاء حساب لشخص غير موجود أو غير حاضر عند
                          التسجيل، أو لا يؤكد شروط هذه الاتفاقية.
                        </li>
                        <li>يجب التنبيه إلى أن الانتحال يعد جريمة جنائية.</li>
                        <li>
                          في حالة المستخدم الذي هو شركة:
                          <ol>
                            <li>
                              يُعتبر الشخص الذي فتح الحساب نيابة عن الشركة
                              ("المعتمد الأصلي") هو المستخدم لجميع الأغراض.
                            </li>
                            <li>
                              إذا رغب المستخدم (الشركة) في استبدال المرخص له
                              الأصلي برخصة جديدة:
                              <ol>
                                <li>
                                  عليه تقديم نموذج مرخص يوضح المعتمد الجديد
                                  (واحد أو أكثر) للعمل نيابة عن الشركة.
                                </li>
                                <li>
                                  يجب أن يحتوي النموذج على تحقق من المحامي يثبت
                                  صلاحية المعتمد الجديد قانونياً.
                                </li>
                                <li>
                                  عند استلام نموذج الترخيص الجديد، تقوم الشركة
                                  بتحويل استخدام النظام الأساسي إلى المرخص له
                                  الجديد، ويعتبر المستخدم لجميع الأغراض.
                                </li>
                                <li>
                                  يتم إلغاء الترخيص الأصلي لجميع السلطات والحقوق
                                  المتعلقة بالمنصة والموقع، ولا يحق للمرخص له
                                  الأصلي المطالبة بشيء بهذا الشأن.
                                </li>
                              </ol>
                            </li>
                          </ol>
                        </li>
                      </ol>
                    </li>
                    <li>
                      توضح الشركة أنه رغم اتخاذها الإجراءات القانونية لتأمين
                      محتوى حساب المستخدم، إلا أنها لا تضمن عدم الكشف التام عن
                      الحساب بسبب اختراق غير مصرح به.
                      <ol>
                        <li>
                          في حالة حدوث اختراق، لن يكون لدى المستخدم أي مطالبة
                          تعويضية ضد الشركة عن الأضرار الناتجة عن ذلك.
                        </li>
                      </ol>
                    </li>
                    <li>
                      يتعهد المستخدم بالالتزام بالقواعد التالية المتعلقة بكلمة
                      المرور ("كلمة المرور") المستخدمة للوصول إلى حساب المستخدم
                      وإجراء عمليات على المنصة:
                      <ol>
                        <li>
                          يجب عدم الكشف عن كلمة المرور لأي طرف ثالث أو إدخالها
                          في بريد إلكتروني غير آمن.
                        </li>
                        <li>
                          يجب أن تحتوي كلمة المرور على ما بين 8 إلى 16 حرفاً.
                        </li>
                        <li>
                          يجب على المستخدم إبلاغ الشركة فوراً بأي استخدام مشبوه
                          أو غير مصرح به لحسابه.
                        </li>
                      </ol>
                    </li>
                    <li>
                      يؤكد المستخدم موافقته على استلام التحديثات والإشعارات من
                      الشركة على البريد الإلكتروني المسجل في حساب المستخدم،
                      والتي تشمل:
                      <ol>
                        <li>
                          التحديثات والموافقات المتعلقة بإجراءات المستخدم على
                          الموقع.
                        </li>
                        <li>
                          أي إشعارات أخرى، مثل النشرات الإخبارية أو الإعلانات.
                        </li>
                      </ol>
                    </li>
                    <li>
                      أثناء استخدام حساب المستخدم، يختار المستخدم تزويد الشركة
                      بمعلومات تخص أطراف ثالثة لمنح ترخيص له.
                      <ol>
                        <li>
                          سيتم الاحتفاظ بهذه المعلومات في قواعد بيانات الشركة.
                        </li>
                        <li>
                          سيتم استخدام هذه المعلومات وفقاً لسياسة الخصوصية
                          الخاصة بالشركة.
                        </li>
                        <li>
                          يؤكد المستخدم أن جمع هذه المعلومات تم وفق الأصول
                          القانونية، ويوافق على استخدامها بما يتوافق مع سياسة
                          الخصوصية وحاجات الترخيص.
                        </li>
                      </ol>
                    </li>
                  </ul>
                  <div className="card-header">
                    <h3 className="text-primary card-title">فترة الخبرة</h3>
                  </div>

                  <ul className="text-primary-ol list-disc p-3 pt-0">
                    {" "}
                    <li>
                      مع التسجيل للموقع، يتم منح المستخدم فترة تجريبية مجانية
                      لمدة 60 يوماً، والتي تبدأ بحساب التشغيل والموافقة على
                      عنوان البريد الإلكتروني من قبل الشركة ("الفترة
                      التجريبية").
                    </li>
                    <li>
                      دون الانحراف عما تقدم، يتم توضيح والاتفاق على ما يلي:
                      <ol>
                        <li>
                          في أي حال، تقتصر مسؤولية الشركة بموجب هذه الاتفاقية
                          على المبلغ المساوي للمبالغ المتراكمة التي دفعها
                          المستخدم للشركة لمدة 3 أشهر فقط، إلا في حالة الإجراءات
                          الضارة للشركة.
                        </li>
                        <li>
                          لن تكون الشركة مسؤولة في أي حال عن المحتوى الذي يتم
                          رفعه أو نقله أو نشره من خلال النظام الأساسي.
                          <ol>
                            <li>
                              تنطبق مسؤولية هذه الإجراءات فقط على المستخدم.
                            </li>
                            <li>
                              لا يجوز تقديم أي مطالبة ضد الشركة في هذا الصدد.
                            </li>
                            <li>
                              المستخدم هو المسؤول الوحيد عن الجهاز الذي يستخدمه
                              كجزء من الترخيص، بما في ذلك أمانه.
                            </li>
                            <li>
                              بعض الإجراءات التي يقوم بها المستخدم على الجهاز،
                              مثل "اختراقه"، قد تضعف أمن المعلومات وقد تكون غير
                              شرعية وممنوعة.
                            </li>
                          </ol>
                        </li>
                        <li>
                          توضح الشركة أنها لا تضمن أن المنصة ستعمل بنسبة 100٪
                          طوال الوقت.
                          <ol>
                            <li>
                              من وقت لآخر، تقوم الشركة بتحديث وترقية أنظمة
                              النظام الأساسي، مما قد يسبب توقفاً مؤقتاً للنشاط.
                            </li>
                            <li>
                              الشركة لا تسيطر على توفر المنتجات أو الخدمات التي
                              تقدمها أطراف ثالثة.
                            </li>
                          </ol>
                        </li>
                        <li>
                          الضمان للمستخدم هو التحقق من سلامة اتصال الإنترنت قبل
                          استخدام النظام الأساسي.
                          <ol>
                            <li>
                              لا تتحمل الشركة أي مسؤولية عن الأضرار الناتجة عن
                              مشاكل اتصال المستخدم بالإنترنت.
                            </li>
                          </ol>
                        </li>
                        <li>
                          أنظمة الشركة، المبنية على برامج وأجهزة وشبكات اتصالات،
                          معرضة للمخاطر التالية:
                          <ol>
                            <li>البرامج الضارة (فيروسات، خيول طروادة، إلخ).</li>
                            <li>السطو من قبل الجهات المعادية.</li>
                            <li>التنبؤ بمواقع الشركة أو أنظمتها.</li>
                            <li>الاحتيال عبر الإنترنت.</li>
                          </ol>
                          تبذل الشركة جهوداً كبيرة للحماية، لكنها لا تضمن
                          إمكانية الحجب تماماً وقد تحدث أضرار أو خسائر بسبب هذه
                          المخاطر، بما في ذلك:
                          <ol>
                            <li>كشف أو تعطيل المعلومات المنقولة أو المقدمة.</li>
                            <li>تعطيل التعليمات أو الطلبات.</li>
                            <li>الإجراءات غير المصرح بها.</li>
                            <li>
                              اضطرابات في إجراء الأنظمة أو أوقات الاستجابة.
                            </li>
                            <li>
                              الفشل أو الأداء غير الصحيح أو تنفيذ الطلبات.
                            </li>
                            <li>عدم توافر الأنظمة أو العمليات.</li>
                          </ol>
                          لا تكون الشركة مسؤولة عن أي ضرر ناتج عن هذه الظروف.
                        </li>
                        <li>
                          لا تتحمل الشركة تحت أي ظرف مسؤولية الأضرار أو الخسائر
                          أو النفقات الناتجة عن استخدام أو عطل أو خطأ أو تعطيل
                          في أي نظام مطور من طرف ثالث يتيح التواصل مع المنصة أو
                          الموقع، والذي يقدم الخدمات للمستخدم من خلال هذا النظام
                          وليس من خلال المنصة أو الموقع مباشرة.
                        </li>
                        <li>
                          لا تهدف المعلومات والمحتوى المقدم على النظام الأساسي
                          إلى استبدال المحاسبة أو الضرائب أو أي نصيحة أخرى.
                          <ol>
                            <li>
                              لا تقدم الشركة مشورة أو خدمات استشارية من أي نوع.
                            </li>
                            <li>
                              واجِب المستخدم هو طلب الاستشارة حسب الحاجة وليس
                              الاعتماد فقط على المعلومات في النظام الأساسي.
                            </li>
                            <li>
                              لا تعتبر الاستجابات من الشركة دعماً تشغيلياً أو
                              خدمة عملاء أو نصيحة مسؤولة أو ضريبية أو غيرها.
                            </li>
                          </ol>
                        </li>
                      </ol>
                    </li>
                  </ul>
                  <div className="card-header">
                    <h3 className="text-primary card-title"> التعويض</h3>
                  </div>

                  <ul className="text-primary-ol list-disc p-3 pt-0">
                    {" "}
                    <li>
                      {" "}
                      يتعهد المستخدم بأنه سيعوض الشركة وتعويضها ، عن أي خسارة أو
                      أضرار أو مفقودة (بما في ذلك النفقات ورسوم المحامي) التي
                      ستتسبب في إحالة الشركة ، فيما يتعلق بأي متطلبات أو مطالبة
                      ، نتيجة لاستخدام المستخدم من المنصة بطريقة تنتهك شروط
                      الاستخدام ؛ كل هذا ، في غضون 30 يوماً من تلقي طلب الشركة
                      لأول مرة كتابياً.
                    </li>
                    <li>
                      {" "}
                      لا ينتقص القسم 8 من أي حق أو إغاثة أخرى ، والتي تخضع
                      للشركة بموجب هذه الاتفاقية أو بأي قانون.
                    </li>
                  </ul>
                  <div className="card-header">
                    <h3 className="text-primary card-title">
                      عدم وجود روابط بارزة
                    </h3>
                  </div>
                  <ul className="text-primary-ol list-disc p-3 pt-0">
                    <li>
                      تظهر بعض الروابط (الروابط المفرطة) التي تشير إلى مواقع
                      تابعة للإدارة أو ملكية طرف ثالث.
                    </li>
                    <li>
                      تم توضيح أن الارتباط بهذه المواقع هو فقط لراحة المستخدم،
                      وأن الشركة:
                      <ol>
                        <li>لا تفحص هذه المواقع،</li>
                        <li>لا تدعمها،</li>
                        <li>
                          ولا تتحمل المسؤولية عنها، سواء عن محتواها أو أمنها.
                        </li>
                      </ol>
                      <p>
                        التصفح أو استخدام أو توصيل المعلومات إلى هذه المواقع
                        يكون على المسؤولية الكاملة للمستخدم.
                      </p>
                    </li>
                    <li>
                      يجب التأكيد على أنه لا يوجد تمييز بين الروابط الداخلية
                      والروابط الخارجية، وأن مسؤولية المستخدم هي التحقق من عنوان
                      URL قبل استخدام الرابط.
                    </li>
                    <li>
                      إذا وجد المستخدم معلومات على خدمات طرف ثالث مرتبطة بهذه
                      الروابط تحتوي على محتوى:
                      <ol>
                        <li>مضلل،</li>
                        <li>غير قانوني،</li>
                        <li>أو غير أخلاقي،</li>
                        <li>أو أي محتوى مخالف آخر،</li>
                      </ol>
                      يُطلب من المستخدم إبلاغ شركة خدمة العملاء بذلك من خلال
                      خدمة العملاء.
                    </li>
                  </ul>

                  <div className="card-header">
                    <h3 className="text-primary card-title">الملكية الفكرية</h3>
                  </div>
                  <ul className="text-primary-ol list-disc p-3 pt-0">
                    <li>
                      حقوق الملكية الفكرية الكاملة (حقوق الطبع والنشر، العلامات
                      التجارية، النماذج، البراءات، الأسرار التجارية) على الموقع،
                      المنصة، التطبيق، الكود، الرسوميات، النصوص، قواعد البيانات
                      (بما فيها بيانات المستخدم) وأي تفاصيل أخرى هي ملك حصري
                      للشركة أو لطرف ثالث سمح للشركة باستخدامها.
                    </li>
                    <li>
                      لا تمنح هذه الاتفاقية المستخدم أي حقوق ترخيص أو ملكية
                      فكرية في الشركة، باستثناء الحق في استخدام المنصة أو الموقع
                      وفق شروط الاستخدام.
                    </li>
                    <li>
                      اسم "الفاتورة الخضراء" والعلامات التجارية والرموز هي ملك
                      للشركة ولا يجوز استخدامها إلا بما يسمح به الاتفاق.
                    </li>
                    <li>
                      لا يجوز للمستخدم استخدام المنصة أو أجزائها بطريقة تتعارض
                      مع الاتفاق أو تنتهك حقوق الشركة أو الغير دون موافقة كتابية
                      من الشركة.
                    </li>
                    <li>
                      الشركة قد تستخدم وسائل تقنية لمنع الاستخدام غير المصرح به،
                      ويتعهد المستخدم بعدم محاولة تجاوزها.
                    </li>
                    <li>
                      يمنح المستخدم الشركة إذنًا لا رجعة فيه لاستخدام المعلومات
                      التي يقدمها أو تجمع تلقائياً لتوليد معلومات إحصائية
                      مجهولة، والتي تظل ملكاً حصرياً للشركة مع كل الحقوق.
                    </li>
                    <li>هذه الأحكام تستمر بعد إنهاء الاتفاقية.</li>
                  </ul>

                  <div className="card-header">
                    <h3 className="text-primary card-title">
                      تغيير شروط الاتفاقية؛ نهاية الاتفاق
                    </h3>
                  </div>
                  <ul className="text-primary-ol list-disc p-3 pt-0">
                    <li>
                      الشركة لها الحق في تغيير أو إيقاف شروط الاتفاقية في أي وقت
                      مع إشعار المستخدمين.
                    </li>
                    <li>
                      يمكن للشركة إنهاء الاتفاقية لأي سبب مع إشعار مدته 30
                      يومًا، أو فورًا عند انتهاك المستخدم للشروط، دون السماح بأي
                      مطالبات.
                    </li>
                  </ul>

                  <div className="card-header">
                    <h3 className="text-primary card-title">
                      عدم وجود علاقات عمل صاحب العمل
                    </h3>
                  </div>
                  <ul className="text-primary-ol list-disc p-3 pt-0">
                    <li>
                      {" "}
                      <p>
                        تم توضيح أن استخدام المنصة لا ينشئ أي علاقة عمل، وكالة،
                        شراكة، أو غيرها بين المستخدم والشركة.
                      </p>
                    </li>
                  </ul>

                  <div className="card-header">
                    <h3 className="text-primary card-title">فحص الحقوق</h3>
                  </div>
                  <ul className="text-primary-ol list-disc p-3 pt-0">
                    <li>
                      <p>
                        لا يمكن للمستخدم التنازل عن حقوقه أو نقلها دون موافقة
                        مسبقة من الشركة. الشركة يمكنها منح الترخيص لطرف ثالث مع
                        استمرار الالتزام تجاه المستخدم.
                      </p>
                    </li>
                  </ul>

                  <div className="card-header">
                    <h3 className="text-primary card-title">الدعم الفني</h3>
                  </div>
                  <ul className="text-primary-ol list-disc p-3 pt-0">
                    <li>
                      توفير الدعم الفني عبر نموذج الاتصال في صفحة "اتصل بنا".
                    </li>
                    <li>الدردشة على الموقع مع استجابة خلال 24 ساعة.</li>
                    <li>ساعات الدعم من 09:00 إلى 18:00 خلال أيام العمل.</li>
                  </ul>

                  <div className="card-header">
                    <h3 className="text-primary card-title">
                      سلطة الحكم والحكم
                    </h3>
                  </div>
                  <ul className="text-primary-ol list-disc p-3 pt-0">
                    <li>
                      {" "}
                      <p>
                        الاختصاص القضائي الحصري للقضايا المتعلقة بالاتفاقية هو
                        محكمة القدس فقط، ويطبق القانون المحلي فقط.
                      </p>
                    </li>
                  </ul>

                  <hr className="text-primary" />

                  <h4 className="text-primary text-center">
                    يمكنك الاتصال بنا لطرح أي أسئلة بخصوص سياسة الخصوصية على
                    نموذج الاتصال ، والذي يظهر على صفحة "اتصل بنا" على الموقع
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Page Content */}
      </div>
    </>
  );
};
export default TermsandConditions;
